// styles
import styles from './styles.module.scss';

// components
import UILink from '../Buttons/UILink';
import Typography from '../Typography/Typography';
import FlexColumn from '../FlexBox/FlexColumn';
import FlexRow from '../FlexBox/FlexRow';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className={styles['footer']}>
      <FlexRow className={styles['footer-container']} >
        <FlexColumn gap='0' alignItems='start' width='fit-content'>
          <Typography variant={"b3M"} color='var(--grey-400)' >{`Spintly Partners | ${year} Admin`}</Typography>
          <Typography variant={"b3R"} color='var(--grey-400)' >{`© ${year} All Rights Reserved`}</Typography>
        </FlexColumn>
        <FlexRow width='fit-content'>
          <UILink text="About Us" alternate handleSubmit={() => { }} />
          <p>|</p>
          <UILink text="Contact Us" alternate handleSubmit={() => { }} />
          <p>|</p>
          <UILink text="Privacy" alternate handleSubmit={() => { }} />
        </FlexRow>
      </FlexRow>
    </footer>
  );
};

export default Footer;
